export default {
  namespaced: true,
  state: {
    sliderItems: [],
  },
  getters: {
    getBackgroundImage: function(state) {
      return state.sliderItems.map((item) => item.backgroundImageLink);
    },
  },
  mutations: {
    setSliderItems: function(state, items) {
      if (items) state.sliderItems = items;
    },
  },
  actions: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/slider.js